<template>
  <div id="app">
    <!--<audio class="audio" ref='audio'  crossOrigin="anonymous" >-->
      <!--<source src="./assets/music.mp3" type="audio/mp3">-->
    <!--</audio>-->
    <transition :name="transitionName">
      <router-view/>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      transitionName: ''
    }
  },
  mounted() {
//    const audio = this.$refs.audio
//    audio.addEventListener('ended', function () {
//      audio.play()
//    }, false);
    if(this.$route.name!=='Index' || this.$route.name!=='Video') {
      this.$router.replace('/video')
    }
  },
  watch: {
    '$route' (to, from) {
      if(from.name !== 'Index') {
        this.transitionName = 'fade'
      }
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
}
  html,body,#app {
    width: 100%;
    height: 100%;
    margin:0;
    padding:0;
    -webkit-tap-highlight-color: transparent;
    background-color: #000;
  }
  .audio {
    visibility: hidden
  }

.fade-enter-active {
  transition: opacity 0.5s 0.3s linear;
}
.fade-leave-active {
  transition: opacity 0.3s linear;
}
.fade-enter{
  opacity: 0.5;
}
.fade-leave-to {
  opacity: 0.4;
}

.img-point {
  pointer-events: none;
}

</style>



// WEBPACK FOOTER //
// src/App.vue